import React, { useEffect, useRef } from "react";
import BouncingDiv from "../BouncingDiv";
import BodyVid from "../assets/videos/foot-body.mp4";
import YMLogo from "../assets/YMLogo";

export default function Body({ setAverageColor, setOppositeColor }) {
  const canvasRef = useRef();
  const videoRef = useRef();

  // useEffect(() => {
  //   if (!videoRef.current || !setAverageColor || !setOppositeColor) return;
  //   const video = videoRef.current;
  //   const canvas = canvasRef.current;
  //   const ctx = canvas.getContext("2d");
  //   const processFrame = () => {
  //     canvas.width = video.videoWidth;
  //     canvas.height = video.videoHeight;
  //     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  //     const pixelData = ctx.getImageData(
  //       0,
  //       0,
  //       canvas.width,
  //       canvas.height,
  //     ).data;
  //     // Calculate average color
  //     let sumRed = 0,
  //       sumGreen = 0,
  //       sumBlue = 0;
  //     for (let i = 0; i < pixelData.length; i += 4) {
  //       sumRed += pixelData[i];
  //       sumGreen += pixelData[i + 1];
  //       sumBlue += pixelData[i + 2];
  //     }
  //     const numPixels = pixelData.length / 4;
  //     const averageRed = Math.round(sumRed / numPixels);
  //     const averageGreen = Math.round(sumGreen / numPixels);
  //     const averageBlue = Math.round(sumBlue / numPixels);
  //     // console.log(averageRed, averageGreen, averageBlue);
  //     setAverageColor(`rgb(${averageRed}, ${averageGreen}, ${averageBlue})`);
  //     const oppositeRed = 255 - averageRed;
  //     const oppositeGreen = 255 - averageGreen;
  //     const oppositeBlue = 255 - averageBlue;
  //     setOppositeColor(
  //       `rgb(${oppositeRed}, ${oppositeGreen}, ${oppositeBlue})`,
  //     );
  //   };
  //   const intervalId = setInterval(processFrame, 1000 / 30); // Adjust frame rate as needed
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, []);
  return (
    <div
      id="bounce-container"
      className="relative flex h-[100dvh] min-w-[100dvw] flex-1 shrink-0  snap-center items-center justify-center bg-amber-100"
    >
      <canvas ref={canvasRef} className=" hidden h-[10vh] w-full" />
      <video
        autoPlay
        id="video-background"
        ref={videoRef}
        muted
        loop
        playsInline
        className="absolute flex h-full w-full object-cover "
        onLoad={() => {
          console.log("loaded");
        }}
      >
        <source src={BodyVid} type="video/mp4" />
      </video>
      <div className="absolute top-1/2 z-[80] flex h-[30vw] w-[80%] -translate-y-1/2 items-center rounded-md  text-[10vw] font-[800] mix-blend-difference ">
        <div
          className="flex min-h-[100%] min-w-[100%] animate-fade cursor-pointer rounded-md bg-[red]"
          onClick={() => {
            window.open(
              "https://www.youtube.com/watch?v=OsDB7ZTkeT8",
              "_blank",
            );
          }}
        />
        <p className=" absolute w-full  justify-center pl-[40px] text-center tracking-[40px] text-white opacity-[100%] mix-blend-plus-lighter">
          BODY
        </p>
        <p className="absolute bottom-[2%] right-[2%] text-[2vw] tracking-normal text-white opacity-[100%]">
          FOOT x AZMUTH
        </p>
      </div>
      <BouncingDiv size={50}>
        <YMLogo />
      </BouncingDiv>
    </div>
  );
}
